import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { RemoveRedEye, ReplayCircleFilledOutlined } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import {
  blueTickApproveReject,
  getBlueTickApplyList,
  getBlueTickQuestionAnswer,
  getBlueTickRejectReason
} from "src/api/commonapi";
import Label from "src/components/Label";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Routes } from "src/constant/api_url";
import { useLocation } from "react-router-dom";
import CustomLoader from "src/commonComponents/CustomLoader";
import moment from "moment";

export default function BlueTickApplyList() {
  const bluetickDetailModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const QuestionAnswerModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const renderStars = (rating) => {
    const maxStars = 5;
    const filledStars = "★".repeat(Math.round(rating)); // Filled stars
    const emptyStars = "☆".repeat(maxStars - Math.round(rating)); // Empty stars

    return <span style={{ color: "gold", fontSize: "16px" }}>{filledStars + emptyStars}</span>;
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();

  const bluetickApproveRejectOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Rejected", value: 1 },
    { label: "Approved", value: 2 }
  ];

  const memberRatings = [
    { label: "All", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 }
  ];

  const [rejectReason, setRejectReason] = useState({ id: "", title: "" });
  const [bluetickRejectReasonDataModal, setBlueTickRejectReasonDataModal] = useState(false);
  const [bluetickRejectReason, setBlueTickRejectReason] = useState([]);
  const [selectedBlueTickStatusData, setSelectedBlueTickStatusData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [chaptlist, setchaplist] = useState([]);
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0,
    chpt_id: 0,
    mgt_status: -1,
    searchmember: "",
    ratings: 0,
    startDate: null,
    endDate: null
  });
  const [bluetickData, setBlueTickData] = useState([]);
  const [newBlueTickData, setNewBlueTickData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [bluetickDataAll, setBlueTickDataAll] = useState([]); // store full dataset

  const [QuestionAnswerModalData, setQuestionAnswerModalData] = useState(false);
  const [mgtQuestionAnswerList, setMgtQuestionAnswerList] = useState([]);

  const [qaExportData, setQaExportData] = useState([]);
  const csvLinkRef = useRef();

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  // Open modal with bluetick ID
  const openApproveRejectModal = async (bluetickdata) => {
    setSelectedBlueTickStatusData({
      ...bluetickdata,
      status: bluetickdata?.mgt_status // Save current status
    });

    if (bluetickdata?.mgt_status === 1) {
      const matchedReason = bluetickRejectReason.find(
        (r) => r.bluetick_r_id === bluetickdata?.mgt_reject_reason
      );

      if (matchedReason) {
        setRejectReason({
          id: matchedReason.bluetick_r_id,
          title: matchedReason.bluetick_reject_reason
        });
      } else {
        setRejectReason({ id: "", title: "" }); // fallback if not found
      }
    } else {
      setRejectReason({ id: "", title: "" }); // clear
    }

    setBlueTickRejectReasonDataModal(true); // Open modal
  };

  // Close modal and reset state
  const closeModal = () => {
    setBlueTickRejectReasonDataModal(false);
    setQuestionAnswerModalData(false);
  };

  const getBlueTickRejectReasonData = async () => {
    let res = await getBlueTickRejectReason();
    setBlueTickRejectReason(res);
  };

  const handleCSVExportWithQA = async () => {
    const allExportData = await Promise.all(
      newBlueTickData.map(async (row) => {
        const statusLabel =
          row.mgt_status === 2 ? "Approved" : row.mgt_status === 1 ? "Rejected" : "Pending";

        const base = {
          No: row.b_id,
          "Member Name": row.m_name,
          "Chapter Name": row.chpt_name,
          "Apply Date": row.mgt_apply_date || "-",
          Rating: row.mgt_ratings || "-",
          "Approved Date": row.mgt_approve_date || "-",
          "Rejected Date": row.mgt_reject_date || "-",
          "Approved/ Rejected By": row.approve_by_name || "-",
          Status: statusLabel,
          "Reject Reason": row.bluetick_reject_reason || "-"
        };

        // Fetch question/answers
        let qaText = "No Question Answer";
        try {
          setIsLoading(true);

          const qaRes = await getBlueTickQuestionAnswer(row.b_id);
          setIsLoading(false);
          if (qaRes.status === 1) {
            qaText = qaRes.data
              .map((qa) => `${qa.mgt_question}: ${qa.mgt_ans === 1 ? "Yes" : "No"}`)
              .join(" | ");
          }
        } catch {
          qaText = "Error loading Q/A";
        }

        const tabFields =
          selectedTab === 0
            ? {
                "Start Image URL": row.mgt_start_img
                  ? `${Routes.API_HOSTNAME}images/bluetick/${row.mgt_start_img}`
                  : "-",
                "End Image URL": row.mgt_end_img
                  ? `${Routes.API_HOSTNAME}images/bluetick/${row.mgt_end_img}`
                  : "-",
                "MGT Title": row.mgt_title || "-"
              }
            : {
                "Offline Taken By": row.mgt_offline_taken_by || "-",
                "Offline Image URL": row.mgt_offline_img
                  ? `${Routes.API_HOSTNAME}images/bluetick/${row.mgt_offline_img}`
                  : "-",
                "Offline Attend Date": row.mgt_offline_date || "-"
              };

        return {
          ...base,
          ...tabFields,
          "Question/Answer": qaText
        };
      })
    );

    setQaExportData(allExportData);

    setTimeout(() => {
      csvLinkRef.current.link.click(); // trigger download
    }, 100);
  };

  const columns = [
    {
      name: "No",
      selector: (row) => row.b_id,
      wrap: true,
      width: "100px",
      sortable: true
    },
    {
      name: "Member Name",
      selector: (row) => row.m_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Chapter Name",
      selector: (row) => row.chpt_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Apply Date",
      selector: (row) => row.mgt_apply_date,
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Rating",
      selector: (row) => renderStars(row?.mgt_ratings), // Unicode-based stars
      sortable: true,
      width: "120px"
    },
    ...(selectedTab === 0
      ? [
          // Online tab (mgt_type = 0)
          {
            name: "MGT Start Image",
            cell: (row) =>
              row.mgt_start_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_start_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_start_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "MGT End Image",
            cell: (row) =>
              row.mgt_end_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_end_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_end_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "MGT",
            cell: (row) => {
              const content = row.mgt_title ?? "-";
              return (
                <div title={content}>
                  {content.length > 30 ? content.slice(0, 30) + "..." : content}
                </div>
              );
            },
            sortable: true,
            width: "150px",
            wrap: false
          },
          {
            name: "MGT Start Date",
            selector: (row) => row.mgt_sdate,
            sortable: true,
            width: "110px",
            wrap: true
          },
          {
            name: "MGT End Date",
            selector: (row) => row.mgt_edate,
            sortable: true,
            width: "110px",
            wrap: true
          }
        ]
      : [
          // Offline tab (mgt_type = 1)
          {
            name: "Offline MGT Taken By",
            selector: (row) => row.mgt_offline_taken_by,
            sortable: true,
            wrap: true
          },
          {
            name: "Offline MGT Image",
            cell: (row) =>
              row.mgt_offline_img ? (
                <a
                  href={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_offline_img}`}
                  target="_blank"
                >
                  <img
                    src={`${Routes.API_HOSTNAME}images/bluetick/${row.mgt_offline_img}`}
                    alt="img"
                    width="100"
                  />
                </a>
              ) : (
                "-"
              ),
            width: "150px"
          },
          {
            name: "Offline MGT Attend Date",
            selector: (row) => row.mgt_offline_date,
            sortable: true,
            wrap: true
          }
        ]),
    {
      name: "Approved Date",
      selector: (row) => (row.mgt_approve_date ? row.mgt_approve_date : "-"),
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Rejected Date",
      selector: (row) => (row.mgt_reject_date ? row.mgt_reject_date : "-"),
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Approved/ Rejected By",
      selector: (row) => (row.approve_by_name ? row.approve_by_name : "-"),
      sortable: true,
      width: "120px",
      wrap: true
    },
    {
      name: "Status",
      wrap: false,
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.mgt_status == 2 ? "success" : row.mgt_status == 1 ? "error" : "warning"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.mgt_status == 2 ? "Approved" : row.mgt_status == 1 ? "Rejected" : "Pending"}
        </Label>
      ),
      sortable: false
    },
    {
      name: "Approve/ Reject",
      width: "90px",
      cell: (row) => (
        <>
          <Tooltip title="Approve/Reject BlueTick">
            <IconButton onClick={() => openApproveRejectModal(row)}>
              <ReplayCircleFilledOutlined color="success" />
            </IconButton>
          </Tooltip>
        </>
      )
    },
    {
      name: "MGT Question/ Answer",
      width: "90px",
      cell: (row) => (
        <>
          <Tooltip title="MGT Question/ Answer">
            <IconButton onClick={() => openQuestionAnswerModal(row.b_id)}>
              <RemoveRedEye color="info" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      mgt_status: -1,
      searchmember: "",
      ratings: 0,
      startDate: null,
      endDate: null
    });
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  useEffect(async () => {
    getallcitylist();
    getBlueTickRejectReasonData();
  }, []);

  const handleSubmitBlueTickStatus = async () => {
    if (!selectedBlueTickStatusData?.status && selectedBlueTickStatusData?.status !== 0) {
      notification({ type: "error", message: "Please select a status." })();
      return;
    }

    if (selectedBlueTickStatusData.status === 1 && !rejectReason.id) {
      notification({ type: "error", message: "Please select a reject reason." })();
      return;
    }

    const payload = {
      b_id: selectedBlueTickStatusData?.b_id,
      m_id: selectedBlueTickStatusData?.m_id,
      mgt_status: selectedBlueTickStatusData?.status,
      mgt_approved_by: loginUser?.u_id,
      mgt_reject_reason: selectedBlueTickStatusData?.status == 1 ? rejectReason.id : null,
      mgt_reject_reason_title: selectedBlueTickStatusData?.status == 1 ? rejectReason.title : null
    };
    try {
      setIsLoading(true);
      const res = await blueTickApproveReject(payload);
      setIsLoading(false);
      if (res?.status === 1) {
        let notify = notification({
          type: "success",
          message: res.message
        });
        notify();
        await GetBlueTickData();
      } else {
        let notify = notification({
          type: "error",
          message: res.message
        });
        notify();
      }
    } catch (err) {
      let notify = notification({
        type: "success",
        message: "Something went wrong!"
      });
      notify();
    }

    // Cleanup
    setBlueTickRejectReasonDataModal(false);
    setRejectReason({ id: "", title: "" });
    setSelectedBlueTickStatusData(null);
  };

  const filterData = () => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (searchdata?.city_id != 0) {
            if (chpt?.city_id == searchdata?.city_id) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    const BlueTickList =
      bluetickDataAll &&
      bluetickDataAll.filter((bluetick) => {
        if (parseInt(bluetick.mgt_type) !== selectedTab) return false;

        const mgtDate = bluetick.mgt_apply_date
          ? moment(bluetick.mgt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        const startDate = searchdata.startDate ? new Date(searchdata.startDate) : null;
        const endDate = searchdata.endDate ? new Date(searchdata.endDate) : null;

        let dateMatch = true;
        if (startDate && endDate && mgtDate) {
          mgtDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          dateMatch = mgtDate >= startDate && mgtDate <= endDate;
        }

        if (
          (bluetick.chpt_id == searchdata?.chpt_id || searchdata?.chpt_id == 0) &&
          selectedCityChapter.length != 0 &&
          selectedCityChapter.includes(bluetick.chpt_id) &&
          (searchdata.mgt_status === -1
            ? [0, 1, 2].includes(bluetick.mgt_status)
            : bluetick.mgt_status === searchdata.mgt_status) &&
          (searchdata.ratings === 0 ||
            parseInt(bluetick.mgt_ratings) === parseInt(searchdata.ratings)) &&
          dateMatch &&
          (bluetick.m_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            bluetick.business_name.toLowerCase().includes(searchdata?.searchmember.toLowerCase()) ||
            bluetick.business_category
              .toLowerCase()
              .includes(searchdata?.searchmember.toLowerCase()) ||
            bluetick.mobile_no.toLowerCase().includes(searchdata?.searchmember.toLowerCase()))
        ) {
          return bluetick;
        }
      });

    setNewBlueTickData(BlueTickList);
  };

  const isFilterApplied = () => {
    return (
      searchdata.city_id !== 0 ||
      searchdata.chpt_id !== 0 ||
      searchdata.mgt_status !== -1 ||
      searchdata.searchmember.trim() !== "" ||
      searchdata.ratings !== 0 ||
      searchdata.startDate !== null ||
      searchdata.endDate !== null
    );
  };

  // useEffect(() => {
  //   filterData();
  // }, [searchdata, bluetickData, selectedTab]);

  useEffect(() => {
    if (!isFilterApplied()) {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      const filteredRecent = bluetickDataAll.filter((item) => {
        const applyDate = item.mgt_apply_date
          ? moment(item.mgt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        return applyDate && applyDate >= oneMonthAgo && parseInt(item.mgt_type) === selectedTab;
      });

      setNewBlueTickData(filteredRecent);
    } else {
      filterData();
    }
  }, [searchdata, bluetickDataAll, selectedTab]);

  // const GetBlueTickData = async () => {
  //   let res = await getBlueTickApplyList(loginUser.city_id, loginUser.u_type);
  //   if (res?.data?.length > 0) {
  //     setBlueTickData(res?.data);
  //   } else {
  //     setBlueTickData([]);
  //   }
  // };

  const GetBlueTickData = async () => {
    setIsLoading(true);

    let res = await getBlueTickApplyList(loginUser.city_id, loginUser.u_type);
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setBlueTickDataAll(res.data); // store full dataset

      // show only 1-month data initially
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      const filteredRecent = res.data.filter((item) => {
        const applyDate = item.mgt_apply_date
          ? moment(item.mgt_apply_date, "DD-MM-YYYY hh:mm A").toDate()
          : null;
        return applyDate && applyDate >= oneMonthAgo;
      });

      setBlueTickData(filteredRecent); // initially show recent only
    } else {
      setBlueTickData([]);
      setBlueTickDataAll([]);
    }
  };

  useEffect(async () => {
    GetBlueTickData();
  }, []);

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.mgt_desc != null && data?.mgt_desc != "" && (
          <p>
            <b>Description</b> : {data?.mgt_desc}
          </p>
        )}
        {data?.bluetick_reject_reason != null && data?.bluetick_reject_reason != "" && (
          <p>
            <b>Reject Reason</b> : {data?.bluetick_reject_reason}
          </p>
        )}
        {data?.mgt_reject_date != null && data?.mgt_reject_date != "" && (
          <p>
            <b>Rejected Date</b> : {data?.mgt_reject_date}
          </p>
        )}
      </div>
    );
  };

  const openQuestionAnswerModal = async (b_id) => {
    setQuestionAnswerModalData(true); // Open modal

    try {
      const resp = await getBlueTickQuestionAnswer(b_id);
      if (resp.status === 1) {
        setMgtQuestionAnswerList(resp.data);
      } else {
        setMgtQuestionAnswerList([]);
      }
    } catch (error) {
      console.error("Error fetching Attachment data:", error);
    }
  };

  return (
    <>
      <Page title="BlueTick Member Requests | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              BlueTick Member Requests
            </Typography>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>BlueTick Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      bluetickApproveRejectOptions &&
                      bluetickApproveRejectOptions.map((option) => {
                        if (option.value == searchdata.mgt_status) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, mgt_status: e.value });
                    }}
                    options={
                      bluetickApproveRejectOptions &&
                      bluetickApproveRejectOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={3}>
                  <label>Select Ratings</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberRatings.map((c) => {
                      if (c.value == searchdata.ratings) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        ratings: e.value
                      });
                    }}
                    options={memberRatings}
                  />
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select BlueTick Apply Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.startDate != null ? searchdata.startDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={3}>
                <Stack spacing={0}>
                  <label>Select BlueTick Apply End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.endDate != null ? searchdata.endDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    name="search"
                    size="small"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid
                xs={1}
                item
                sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px", padding: "15px 10px" }}>
            {bluetickData && (
              <>
                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Button
                        variant={selectedTab === 0 ? "contained" : "outlined"}
                        onClick={() => setSelectedTab(0)}
                        style={{ marginRight: 10 }}
                      >
                        Online MGT Requests
                      </Button>
                      <Button
                        variant={selectedTab === 1 ? "contained" : "outlined"}
                        onClick={() => setSelectedTab(1)}
                      >
                        Offline MGT Requests
                      </Button>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "right" }}>
                      <Button
                        onClick={handleCSVExportWithQA}
                        variant="contained"
                        style={{ marginBottom: 10 }}
                        disabled={isLoading}
                        startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                      >
                        Export CSV
                      </Button>

                      <CSVLink
                        data={qaExportData}
                        filename={`BlueTick_${
                          selectedTab === 0 ? "Online" : "Offline"
                        }_MGT_Requests.csv`}
                        className="d-none"
                        ref={csvLinkRef}
                      />
                    </Grid>
                  </Grid>
                </Stack>

                <DataTable
                  key={selectedTab}
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newBlueTickData != null ? newBlueTickData : []}
                  expandableRows
                  expandableRowsComponent={ExpandableRow}
                  expandableRowDisabled={(row) => !row?.mgt_desc && !row?.bluetick_reject_reason}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        {/* Bluetick Approve/Reject Modal */}
        <Modal
          open={bluetickRejectReasonDataModal}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={bluetickDetailModalStyle}>
            <Typography variant="h6" textAlign="center" style={{ marginBottom: "20px" }}>
              Approve/Reject BlueTick
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 1300 })
                  }}
                  onChange={(e) => {
                    setSelectedBlueTickStatusData((prev) => ({
                      ...prev,
                      status: e.value
                    }));
                    if (e.value !== 1) {
                      setRejectReason({ id: "", title: "" }); // reset reject reason if not rejected
                    }
                  }}
                  value={
                    bluetickApproveRejectOptions.find(
                      (option) => option.value === selectedBlueTickStatusData?.status
                    ) || null
                  }
                  options={bluetickApproveRejectOptions
                    ?.filter((reasons) => reasons?.value != -1)
                    .map((reasons) => ({
                      label: reasons?.label,
                      value: reasons?.value
                    }))}
                />
              </Grid>
              {selectedBlueTickStatusData?.status === 1 && (
                <Grid item xs={12}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 1300 })
                    }}
                    onChange={(e) => {
                      setRejectReason({ id: e.value, title: e.label });
                    }}
                    value={
                      rejectReason?.id
                        ? { value: rejectReason.id, label: rejectReason.title }
                        : null
                    }
                    options={bluetickRejectReason?.map((reasons) => ({
                      label: reasons?.bluetick_reject_reason,
                      value: reasons?.bluetick_r_id
                    }))}
                  />
                </Grid>
              )}
            </Grid>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={handleSubmitBlueTickStatus}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={closeModal}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Question/Answer Modal */}
        <Modal
          open={QuestionAnswerModalData}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={QuestionAnswerModalStyle}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ mb: 1, textAlign: "center" }}
            >
              MGT Question/Answer
            </Typography>
            <hr />

            <Stack sx={{ my: 2 }}>
              {mgtQuestionAnswerList.length > 0 ? (
                <Table
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    overflow: "hidden"
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>
                        <b>Question</b>
                      </TableCell>
                      <TableCell>
                        <b>Answer</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {mgtQuestionAnswerList.map((datalist, index) => (
                      <TableRow key={index}>
                        <TableCell>{datalist.mgt_question}</TableCell>
                        <TableCell>{datalist.mgt_ans === 1 ? "Yes" : "No"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", mt: 1, fontStyle: "italic" }}
                >
                  No Question Answer
                </Typography>
              )}
            </Stack>

            <hr />
            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              <Button variant="outlined" onClick={closeModal}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
